import { Controller } from "@hotwired/stimulus"

// Fills a code input from whichever reader the screen offers. nfc:read and qr:read
// both carry `code`, so both bind straight here; typing stays the always-available
// third route. The bindings are declarative (data-action), so Stimulus unbinds them
// on disconnect.
//
// The Web NFC plumbing used to live here and opened a reader straight from
// connect(). Without a gesture that rejects while the permission is still "ask",
// which this controller swallowed into a silent "manual" state — reader mode never
// armed and Android's own tag dispatch took the card. It now lives in nfc-reader,
// which gates on the persisted permission and puts a tap in front of the prompt.
// submitOnRead belongs to screens where the code IS the whole form — reading it is
// already the request. The cashier screens are the opposite: the code is one field
// next to an amount or an event, and submitting on the tap would send a half-filled
// form.
export default class extends Controller {
  static targets = ["input"]
  static values = { submitOnRead: Boolean }

  // A blank tag with an unreadable serial dispatches no code at all.
  fill({ detail: { code } }) {
    if (!code) return

    this.inputTarget.value = code
    if (this.submitOnReadValue) this.inputTarget.form.requestSubmit()
  }
}
